export default
{
  past_holiday: {
    color: '#757575',
    text: 'Przeszłe',
  },
  current_holiday: {
    color: '#7ddb30',
    text: 'Aktualne',
  },
  future_holiday: {
    color: '#efd92f',
    text: 'Nadchodzące',
  },
};
